import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { ClubProvider } from '../../../../providers/club/club';
import { ProfilePage } from '../../../employee/profile/profile';

/**
 * Generated class for the ClubMembersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-club-members',
  templateUrl: 'club-members.html',
})
export class ClubMembersPage {

  clubId:any = 0;
  clubMembers: any = null;
  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public clubProvider: ClubProvider, public modalCtrl: ModalController) {
    this.clubId = navParams.get('clubId');
  }

  ionViewDidLoad() {
    this.clubProvider.listMembers(this.clubId).subscribe((res) => {
      if(res.success){
        this.clubMembers = res.data;
      }
    })
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

    // Decoding image buffer
    ab2str(arraybuffer) {
      return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
    }

    goToProfile(userId) {
      console.log(userId)
      this.modalCtrl.create(ProfilePage, {userId : userId}).present().then(() => {});
    }

}



// WEBPACK FOOTER //
// ./src/pages/employer/clubs/club-members/club-members.ts